import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import GetIcon from "../../../../utils/Icon";
import Tab1 from "./Tab1";
import Tab2 from "./Tab2";
import Tab3 from "./Tab3";
import Tab4 from "./Tab4";
import printerimg from "../../../../assets/print.png";
import {
	useTotalSupplierGroupListMutation,
	useTotalTerritoryListMutation,
	useTotalCurrencyListMutation,
	usePriceDetailsListMutation,
	useTotalBankAccountListMutation,
	useItemTaxCategoryMutation,
	useTotalTaxWithholdingCategoryListMutation,
	useItemCompanyMutation,
	useCountryListMutation,
	useItemGSTHSNCodeMutation,
	usePostUpdateSupplierMutation,
	useGetItemDetailsDataMutation,
} from "../../../../store/api/itemapi";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import Button from "../../../../Core/Button/Button";
import FormLayoutTwo from "../../../../Core/Layout/FormLayoutTwo";
import Attachment from "../../../../utils/Attachment";
import { usePageState } from "../../../../Hook/usePageState";
import { isStateChanged } from "../../../../utils/stateComparator";
const EditForm = () => {
	// const [tab, settab] = useState(1);
	const navigate = useNavigate();
	const location = useLocation();
	const IdData = location.state?.ItemId;
	const [podata, setpodata] = useState("");
	const [podate, setpodate] = useState(new Date().toISOString().split("T")[0]);
	const [error, setError] = useState("");
	const [ptype, setptype] = useState("Error");
	const [finalstep, setfinalstep] = useState(false);
	const [showError, setShowError] = useState(false);

	// api varibale
	const [ItemSupplierGroupApi] = useTotalSupplierGroupListMutation();
	const [TerritoryListApi] = useTotalTerritoryListMutation();
	const [CurrencyListApi] = useTotalCurrencyListMutation();
	const [PriceDetailsListApi] = usePriceDetailsListMutation();
	const [BankAccountListApi] = useTotalBankAccountListMutation();
	const [ItemTaxCategoryApi] = useItemTaxCategoryMutation();
	const [TaxWithholdingCategoryApi] =
		useTotalTaxWithholdingCategoryListMutation();

	const [ItemGSTHSNCodeApi] = useItemGSTHSNCodeMutation();
	const [CompanyListApi] = useItemCompanyMutation();

	const [CountryListApi] = useCountryListMutation();
	const [UpdateSupplier] = usePostUpdateSupplierMutation();

	// for Tab1
	
	const [SupplierGroup_list, setSupplierGroup_list] = useState([]);
	const [Territory_list, setTerritory_list] = useState([]);
	const [BillingCurrency_list, setBillingCurrency_list] = useState([]);
	const [DefaultCompanyBankAccount_list, setDefaultCompanyBankAccount_list] =
		useState([]);

	const [DefaultPriceList_list, setDefaultPriceList_list] = useState([]);
	const [RepresentsCompany_list, setRepresentsCompany_list] = useState([]);

	// for Tab2
	const [SupplierPrimaryAddress_list, setSupplierPrimaryAddress_list] =
		useState([]);
	const [SupplierPrimaryContact_list, setSupplierPrimaryContact_list] =
		useState([]);

	// for Tab3
	const [TaxCategory_list, setTaxCategory_list] = useState([]);
	const [TaxWithholdingCategory_list, setTaxWithholdingCategory_list] =
		useState([]);

	
	const [fieldErrors, setFieldErrors] = useState({
		SupplierName: false,
		SupplierGroup: false,
		SupplierType: false,
		Territory: false,
	});
	// for api

	const pageStateDefault = {
    tab: 1,
    SupplierName: '',
select_SupplierGroup:'',
SupplierType:'',
select_Territory:'',
Website:'',
IsTransporter:false,
select_BillingCurrency:'',
select_DefaultCompanyBankAccount:'',
select_DefaultPriceList:'',
SupplierDetails:'',
IsInternalSupplier:'',
select_RepresentsCompany:'',

select_SupplierPrimaryAddress:'',
select_SupplierPrimaryContact:'',

TaxID:'',
select_TaxCategory:'',
select_TaxWithholdingCategory:'',
GSTIN_UIN:'',
PAN:'',
GSTCategory:'',

AllowPurchaseInvoiceCreationWithoutPurchaseOrder:false,
IsFrozen:false,
AllowPurchaseInvoiceCreationWithoutPurchaseReceipt:false,
Disabled:false,
BlockSupplier:false,
HoldType:'',
ReleaseDate:''
  };
 const [pageState, setPageState] = usePageState(`Edit Supplier - ${IdData}`, pageStateDefault);


  const { tab, SupplierName, select_SupplierGroup,SupplierType,select_Territory,Website,IsTransporter,select_BillingCurrency,select_DefaultCompanyBankAccount,select_DefaultPriceList,SupplierDetails,IsInternalSupplier,select_RepresentsCompany,select_SupplierPrimaryAddress,select_SupplierPrimaryContact,TaxID,select_TaxCategory,select_TaxWithholdingCategory,GSTIN_UIN,PAN,GSTCategory,AllowPurchaseInvoiceCreationWithoutPurchaseOrder,IsFrozen,AllowPurchaseInvoiceCreationWithoutPurchaseReceipt, Disabled,BlockSupplier,HoldType,ReleaseDate} = pageState;
	
  const handleTabChange = (tabNumber) => {
    setPageState({ ...pageState, tab: tabNumber });
  };
  useEffect(() => {
		const getItemSupplierGroup = async () => {
			const ItemSupplierGroupApiData = await ItemSupplierGroupApi();
			setSupplierGroup_list(ItemSupplierGroupApiData.data.data);
		};

		const getItemTerritory = async () => {
			const ItemTerritoryApiData = await TerritoryListApi();
			setTerritory_list(ItemTerritoryApiData.data.data);
		};

		const getItemBillingCurrency = async () => {
			const ItemBillingCurrencyApiData = await CurrencyListApi();
			setBillingCurrency_list(ItemBillingCurrencyApiData.data.data);
		};
		const getItemDefaultCompanyBankAccount = async () => {
			const ItemDefaultCompanyBankAccountApiData = await BankAccountListApi();
			setDefaultCompanyBankAccount_list(
				ItemDefaultCompanyBankAccountApiData.data.data
			);
		};
		const getItemDefaultPriceList = async () => {
			const ItemDefaultPriceListApiData = await PriceDetailsListApi();
			setDefaultPriceList_list(ItemDefaultPriceListApiData.data.data);
		};
		const getItemSupplierPrimaryAddress = async () => {
			const ItemSupplierPrimaryAddressApiData = await CountryListApi();
			setSupplierPrimaryAddress_list(
				ItemSupplierPrimaryAddressApiData.data.data
			);
		};

		const getItemSupplierPrimaryContact = async () => {
			const ItemSupplierPrimaryContactApiData = await CountryListApi();
			setSupplierPrimaryContact_list(
				ItemSupplierPrimaryContactApiData.data.data
			);
		};
		const getItemTaxCategory = async () => {
			const ItemTaxCategoryApiData = await ItemTaxCategoryApi();
			setTaxCategory_list(ItemTaxCategoryApiData.data.data);
		};

		const getItemTaxWithholdingCategory = async () => {
			const ItemTaxWithholdingCategoryApiData =
				await TaxWithholdingCategoryApi();
			setTaxWithholdingCategory_list(
				ItemTaxWithholdingCategoryApiData.data.data
			);
		};

		const getItemRepresentsCompany = async () => {
			const ItemRepresentsCompanyApiData = await CompanyListApi();
			setRepresentsCompany_list(ItemRepresentsCompanyApiData.data.data);
		};
		getItemSupplierGroup();
		getItemTerritory();
		getItemBillingCurrency();
		getItemDefaultCompanyBankAccount();
		getItemDefaultPriceList();
		getItemSupplierPrimaryAddress();
		getItemSupplierPrimaryContact();
		getItemTaxCategory();
		getItemTaxWithholdingCategory();
		getItemRepresentsCompany();
	}, []);
	const [AttachmentsList, setAttachmentsList] = useState([]); // ✅ Make sure it's an array
	const [status, setStatus] = useState("");
	const [po_response, setpo_response] = useState("");
	const [itemDetails, { data, isLoadin }] = useGetItemDetailsDataMutation();

	useEffect(() => {

		if (!isStateChanged(pageState, pageStateDefault)) {
		if (IdData) {
			itemDetails({ doctype: "Supplier", name: IdData })
				.unwrap()
				.then((response) => {
					const item = response.docs?.[0]; // ✅ safely access first item
					const docinfo = response.docinfo;

					if (!item) return;
					setpodata(response);
					// console.log(item, "Api response");
					setPageState({
                SupplierName: item.supplier_name || "",
                select_SupplierGroup: item.supplier_group || "",
                SupplierType: item.supplier_type || "",
                select_Territory:item.country,
				IsTransporter:item.is_transporter,
				select_BillingCurrency:item.default_currency,
				select_DefaultCompanyBankAccount:item.default_bank_account,
				select_DefaultPriceList:item.default_price_list,
				IsInternalSupplier:item.is_internal_supplier,
				select_RepresentsCompany:item.represents_company,
				SupplierDetails:item.supplier_details,
				Website:item.website,

				select_SupplierPrimaryAddress:item.__onload.addr_list[0],
				select_SupplierPrimaryContact:item.__onload.contact_list[0],
				SupplierPrimaryAddress_list:item.__onload.addr_list,
				SupplierPrimaryContact_list:item.__onload.contact_list,




				TaxID:item.tax_id,
				select_TaxCategory:item.tax_category,
				select_TaxWithholdingCategory:item.tax_withholding_category,
				GSTIN_UIN:item.gstin,
				PAN:item.pan,
				GSTCategory:item.gst_category,


				AllowPurchaseInvoiceCreationWithoutPurchaseOrder:item.allow_purchase_invoice_creation_without_purchase_order,
				AllowPurchaseInvoiceCreationWithoutPurchaseReceipt:item.allow_purchase_invoice_creation_without_purchase_receipt,
				IsFrozen:item.is_frozen,
				Disabled:item.disabled,
				BlockSupplier:item.on_hold,
				HoldType:item.hold_type,
				ReleaseDate:item.release_date,
            })

					setAttachmentsList(docinfo.attachments); // ✅ Correct place
					setStatus(item.disabled);
				})
				.catch((err) => {
					console.error("API Error:", err);
				});
		} else {
			console.warn("No Id Data found in location state");
		}
	}
	}, [IdData, itemDetails]);

	const handleSubmit = async () => {
		setFieldErrors({
			SupplierName: false,
			SupplierGroup: false,
			SupplierType: false,
			Territory: false,
		});

		let hasError = false;
		const newErrors = {
			SupplierName: !pageState.SupplierName,
			SupplierGroup: !pageState.select_SupplierGroup,
			SupplierType: !pageState.SupplierType,
			Territory: !pageState.select_Territory,
		};

		setFieldErrors(newErrors);

		if (!SupplierName) {
			setptype("Error");
			setError("Please fill Supplier Name.");
			setShowError(true);
			return;
		}

		const payload = {
			naming_series: "SUP-.YYYY.-", // start Tab1
			supplier_name: IdData,
			country: pageState.select_Territory,
			supplier_group: pageState.select_SupplierGroup,
			supplier_type: pageState.SupplierType,
			is_transporter: pageState.IsTransporter,
			image: "",
			default_currency: pageState.select_BillingCurrency,
			default_bank_account: pageState.select_DefaultCompanyBankAccount,
			default_price_list: pageState.select_DefaultPriceList,
			is_internal_supplier: pageState.IsInternalSupplier,
			represents_company: pageState.select_RepresentsCompany,
			//extra
			// companies: [
			//     {
			//         "company": "Main Company"
			//     },
			//     {
			//         "company": "Subsidiary A"
			//     }
			// ],
			//end extra
			supplier_details: pageState.SupplierDetails,
			website: pageState.Website,
			// language: "en", //extra

			supplier_primary_address: "", //start Tab 2 select_SupplierPrimaryAddress
			supplier_primary_contact: "", // Tab2 select_SupplierPrimaryContact

			tax_id: pageState.TaxID, //start Tab3
			tax_category: pageState.select_TaxCategory,
			tax_withholding_category: pageState.select_TaxWithholdingCategory,
			gstin: pageState.GSTIN_UIN,
			pan: pageState.PAN,
			gst_category: pageState.GSTCategory,

			// gst_transporter_id: "",  //extra
			// is_reverse_charge_applicable: "",//extra
			// payment_terms: "",//extra
			//extra
			// accounts: [
			//     {
			//         "company": "Main Company",
			//         "account": "Creditors - Tech",
			//         "advance_account": "Advances Paid - Tech"
			//     }
			// ],
			//end extra
			// for Tab4
			allow_purchase_invoice_creation_without_purchase_order:
				pageState.AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
			allow_purchase_invoice_creation_without_purchase_receipt:
				pageState.AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
			is_frozen: pageState.IsFrozen,
			disabled: pageState.Disabled,
			on_hold: pageState.BlockSupplier,
			hold_type: pageState.HoldType,
			release_date: pageState.ReleaseDate,
			// end Tab4

			//extra
			// portal_users: [
			//     {
			//         "user": "supplier1@example.com"
			//     },
			//     {
			//         "user": "supplier2@example.com"
			//     }
			// ]
			// end extra
		};

		console.log("edit supplier payload:", payload);
		try {
			const response = await UpdateSupplier(payload); // RTK mutation or fetch

			function stripHTML(html) {
				const doc = new DOMParser().parseFromString(html, "text/html");
				return doc.body.textContent || "";
			}

			if (response.error) {
				let errorMessage = "Updation failed";

				if (response.error.data && response.error.data._server_messages) {
					try {
						const serverMessages = JSON.parse(
							response.error.data._server_messages
						);
						if (Array.isArray(serverMessages) && serverMessages.length > 0) {
							const parsedMessage = JSON.parse(serverMessages[0]);
							errorMessage = parsedMessage.message || errorMessage;
						}
					} catch (e) {
						console.warn("Failed to parse _server_messages", e);
					}
				} else {
					errorMessage =
						response.error.data?.message ||
						response.error.data?.exception ||
						errorMessage;
				}

				// ✅ Strip any HTML tags like <strong> from the final error message
				errorMessage = stripHTML(errorMessage);

				setptype("Error");
				setError(errorMessage);
				setShowError(true);
				return;
			}

			setpo_response(response.data);
			setError("Supplier updated successfully!");
			setptype("Success");
			setShowError(true);
			// Navigate after a short delay (e.g., 2 seconds)
			setTimeout(() => {
				navigate("/master/supplier/supplier-list"); // 🔁 Replace with your actual route
			}, 2000);
		} catch (err) {
			setError(err?.data?.message || "Unexpected error occurred.");
			setptype("Error");
			setShowError(true);
		}
	};

	return (
	 <FormLayoutTwo
		  title="Edit Supplier"
			breadcrumbs={[
				{ label: "Supplier" },
				{ label: "Supplier List", url: "/master/supplier/supplier-list" },
			]}
		  status={'hide'}
		  finalStep={finalstep}
		  actionButtons={
			<>
			  <Button
				className="custom-view-btn d-flex"
				iconName="IoMdArrowDropdown"
				iconPosition="right"
				style={{ gap: "2px" }}
				iconSize={14}
			  >
				View
			  </Button>
			  <Button
				onClick={() => { }}
				to="/"
				state={po_response?.result}
				style={{ backgroundColor: "#fff", height: "28px" }}
				className="custom-btn-00989blue"
				display={finalstep ? "flex" : "none"}
			  >
				+ Create
			  </Button>
	
			  <Button
				className="custom-btn-bluecolor d-flex"
				iconName="BiCloudUpload"
				style={{ gap: "2px" }}
				iconSize={14}
			  >
				Upload
			  </Button>
	
			  <Button
				className="createbtn d-flex"
				style={{ gap: "2px", height: "28px" }}
				iconName="GrCopy"
				iconSize={12}
			  >
				Duplicate
			  </Button>
	
			  <Button
				className="custom-btn-00989"
				onClick={handleSubmit}
				iconName="LuFilePlus2"
				style={{ gap: "2px", height: "28px" }}
				iconSize={12}
				display={finalstep ? "none" : "flex"}
			  >
				{po_response.result ? "Submit" : "Save"}
			  </Button>
	
			  <Button
				to="/"
				className="px-2"
				imgSrc={printerimg}
				imgStyle={{ width: "21px" }}
			  />
			</>
		  }
		>

		<div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff",flexGrow:'1' }}>
			<div className="col-12 p-0" style={{ backgroundColor: "#eff4f9" }}>
			  <div className="d-flex justify-content-between align-items-end ">
					 <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
					   {/* ------------- General Details Tab ------------- */}
					   <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
						 <a
						   className={
							 tab === 1
							   ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
							   : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
						   }
						   href="javascript:void(0);"
						   onClick={() => handleTabChange(1)}
						 >
						   General Details{" "}
						   {tab === 1 ? (
							 <GetIcon iconName="MdKeyboardArrowDown" size={15} />
						   ) : (
							 <GetIcon iconName="MdKeyboardArrowRight" size={15} />
						   )}
						 </a>
					   </li>
		 
					   {/* ------------- Address & Contact Tab ------------- */}
					   <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
						 <a
						   className={
							 tab === 2
							   ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
							   : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
						   }
						   href="javascript:void(0);"
						   onClick={() => handleTabChange(2)}
						 >
						   Address & Contact{" "}
						   {tab === 2 ? (
							 <GetIcon iconName="MdKeyboardArrowDown" size={15} />
						   ) : (
							 <GetIcon iconName="MdKeyboardArrowRight" size={15} />
						   )}
						 </a>
					   </li>
		 
					   {/* ------------- Tax Tab ------------- */}
					   <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
						 <a
						   className={
							 tab === 3
							   ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
							   : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
						   }
						   href="javascript:void(0);"
						   onClick={() => handleTabChange(3)}
						 >
						   Tax{" "}
						   {tab === 3 ? (
							 <GetIcon iconName="MdKeyboardArrowDown" size={15} />
						   ) : (
							 <GetIcon iconName="MdKeyboardArrowRight" size={15} />
						   )}
						 </a>
					   </li>
		 
					   {/* ------------- Settings Tab ------------- */}
					   <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
						 <a
						   className={
							 tab === 4
							   ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner"
							   : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"
						   }
						   href="javascript:void(0);"
						   onClick={() => handleTabChange(4)}
						 >
						   Settings{" "}
						   {tab === 4 ? (
							 <GetIcon iconName="MdKeyboardArrowDown" size={15} />
						   ) : (
							 <GetIcon iconName="MdKeyboardArrowRight" size={15} />
						   )}
						 </a>
					   </li>
					 </ul>
		 
					  <div
              className="d-flex align-items-center mb-2 px-3"
              style={{ gap: "2px", fontSize: "12px" }}
            >
              <span style={{ position: "relative", top: "-1px" }}>
  <GetIcon className="text-[#4B002B]" iconName="CgAttachment" size={12} />
</span>
<span className="fw-semibold" style={{ color: "#4B002B" }}>
  Attachments
</span> 
            </div>
			  </div>
			</div>
		 <div className=" " style={{ background: '' }}>
                                       <div className="row">
                                             {tab === 1 && (
                                           <div
                                               className="col-12 "
                                               style={{
                                                   visibility: tab == 1 ? "visible" : "hidden",
                                                   height: tab == 1 ? "auto" : "0px",
                                               }}
                                           >
                                               <div className="sidebarbox m-0 ">
               
                                                 
                                                       <Tab1
				
					SupplierName={{
						value: pageState.SupplierName,
						setValue: (val) => setPageState({ ...pageState, SupplierName: val }),
						error: fieldErrors.SupplierName,
						}}
					SupplierGroup=
						{{
						SupplierGroup_list: SupplierGroup_list,
						value: pageState.select_SupplierGroup,
						setValue: (val) => setPageState({ ...pageState, select_SupplierGroup: val }),
						error: fieldErrors.select_SupplierGroup
						}}
						
						SupplierType={{
						SupplierType: SupplierType,
						value: pageState.SupplierType,
						setValue: (val) => setPageState({ ...pageState, SupplierType: val }),
						Error: fieldErrors.SupplierType,
						}}
						Territory={{
						Territory_list: Territory_list,
						value: pageState.select_Territory,
						setValue: (val) => setPageState({ ...pageState, select_Territory: val }),
						Error: fieldErrors.select_Territory,
						}}
						Website={{
						Website: Website,
						value: pageState.Website,
						setValue: (val) => setPageState({ ...pageState, Website: val }),
						Error: fieldErrors.Website,
						}}
						IsTransporter={{
						IsTransporter: IsTransporter,
						value: pageState.IsTransporter,
						setValue: (val) => setPageState({ ...pageState, IsTransporter: val }),
						Error: fieldErrors.IsTransporter,
						}}
	
						BillingCurrency={{
						BillingCurrency_list: BillingCurrency_list,
						value: pageState.select_BillingCurrency,
						setValue: (val) => setPageState({ ...pageState, select_BillingCurrency: val }),
						Error: fieldErrors.select_BillingCurrency,
						}}
						DefaultCompanyBankAccount={{
						DefaultCompanyBankAccount_list: DefaultCompanyBankAccount_list,
						value: pageState.select_DefaultCompanyBankAccount,
						setValue: (val) => setPageState({ ...pageState, select_DefaultCompanyBankAccount: val }),
						Error: fieldErrors.select_DefaultCompanyBankAccount,
						}}
						DefaultPriceList={{
						DefaultPriceList_list: DefaultPriceList_list,
						value: pageState.select_DefaultPriceList,
						setValue: (val) => setPageState({ ...pageState, select_DefaultPriceList: val }),
						Error: fieldErrors.select_DefaultPriceList,
						}}
						
					
						IsInternalSupplier={{
						IsInternalSupplier: IsInternalSupplier,
						value: pageState.IsInternalSupplier,
						setValue: (val) => setPageState({ ...pageState, IsInternalSupplier: val }),
						Error: fieldErrors.IsInternalSupplier,
						}}
						RepresentsCompany={{
						RepresentsCompany_list: RepresentsCompany_list,
						value: pageState.select_RepresentsCompany,
						setValue: (val) => setPageState({ ...pageState, select_RepresentsCompany: val }),
						Error: fieldErrors.select_RepresentsCompany,
						}}
						SupplierDetails={{
						SupplierDetails: SupplierDetails,
						value: pageState.SupplierDetails,
						setValue: (val) => setPageState({ ...pageState, SupplierDetails: val }),
						Error: fieldErrors.SupplierDetails,
						}}
	IdData={IdData}
					/>
                                                  
                                               </div>
                                           </div>
                                            )}
                                              {tab === 2 && (
                                           <div
                                               className="col-12 "
                                               style={{
                                                   visibility: tab == 2 ? "visible" : "hidden",
                                                   height: tab == 2 ? "auto" : "0px",
                                               }}
                                           >
                                               <div className="sidebarbox m-0 ">
                                                   
                                                       <Tab2
					
					SupplierPrimaryAddress={{
						SupplierPrimaryAddress_list: SupplierPrimaryAddress_list,
						value: pageState.select_SupplierPrimaryAddress,
						setValue: (val) => setPageState({ ...pageState, select_SupplierPrimaryAddress: val }),
						Error: fieldErrors.select_SupplierPrimaryAddress,
						}}
					SupplierPrimaryContact={{
						SupplierPrimaryContact_list: SupplierPrimaryContact_list,
						value: pageState.select_SupplierPrimaryContact,
						setValue: (val) => setPageState({ ...pageState, select_SupplierPrimaryContact: val }),
						Error: fieldErrors.select_SupplierPrimaryContact,
						}}
					IdData={IdData}
					/>
                                                   
                                               </div>
                                           </div>
                                           )}
                                            {tab === 3 && (
                                           <div
                                               className="col-12 "
                                               style={{
                                                   visibility: tab == 3 ? "visible" : "hidden",
                                                   height: tab == 3 ? "auto" : "0px",
                                               }}
                                           >
                                               <div className="sidebarbox m-0 ">
                                                  
                                                      <Tab3
					
					TaxID={{
						TaxID: TaxID,
						value: pageState.TaxID,
						setValue: (val) => setPageState({ ...pageState, TaxID: val }),
						Error: fieldErrors.TaxID,
						}}
						TaxCategory={{
						TaxCategory_list: TaxCategory_list,
						value: pageState.select_TaxCategory,
						setValue: (val) => setPageState({ ...pageState, select_TaxCategory: val }),
						Error: fieldErrors.select_TaxCategory,
						}}
						TaxWithholdingCategory={{
						TaxWithholdingCategory_list: TaxWithholdingCategory_list,
						value: pageState.select_TaxWithholdingCategory,
						setValue: (val) => setPageState({ ...pageState, select_TaxWithholdingCategory: val }),
						Error: fieldErrors.select_TaxWithholdingCategory,
						}}
						GSTIN_UIN={{
						GSTIN_UIN: GSTIN_UIN,
						value: pageState.GSTIN_UIN,
						setValue: (val) => setPageState({ ...pageState, GSTIN_UIN: val }),
						Error: fieldErrors.GSTIN_UIN,
						}}
						PAN={{
						PAN: PAN,
						value: pageState.PAN,
						setValue: (val) => setPageState({ ...pageState, PAN: val }),
						Error: fieldErrors.PAN,
						}}
						GSTCategory={{
						GSTCategory: GSTCategory,
						value: pageState.GSTCategory,
						setValue: (val) => setPageState({ ...pageState, GSTCategory: val }),
						Error: fieldErrors.GSTCategory,
						}}
					IdData={IdData}
					/>
                                                   
                                               </div>
                                           </div>
                                           )}
                                           {tab === 4 && (
                                           <div
                                               className="col-12 "
                                               style={{
                                                   visibility: tab == 4 ? "visible" : "hidden",
                                                   height: tab == 4 ? "auto" : "0px",
                                               }}
                                           >
                                               <div className="sidebarbox m-0 ">
                                                   
                                                      <Tab4
					
						AllowPurchaseInvoiceCreationWithoutPurchaseOrder={{
						AllowPurchaseInvoiceCreationWithoutPurchaseOrder: AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
						value: pageState.AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
						setValue: (val) => setPageState({ ...pageState, AllowPurchaseInvoiceCreationWithoutPurchaseOrder: val }),
						Error: fieldErrors.AllowPurchaseInvoiceCreationWithoutPurchaseOrder,
						}}
						IsFrozen={{
						IsFrozen: IsFrozen,
						value: pageState.IsFrozen,
						setValue: (val) => setPageState({ ...pageState, IsFrozen: val }),
						Error: fieldErrors.IsFrozen,
						}}
						AllowPurchaseInvoiceCreationWithoutPurchaseReceipt={{
						AllowPurchaseInvoiceCreationWithoutPurchaseReceipt: AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
						value: pageState.AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
						setValue: (val) => setPageState({ ...pageState, AllowPurchaseInvoiceCreationWithoutPurchaseReceipt: val }),
						Error: fieldErrors.AllowPurchaseInvoiceCreationWithoutPurchaseReceipt,
						}}
						Disabled={{
						Disabled: Disabled,
						value: pageState.Disabled,
						setValue: (val) => setPageState({ ...pageState, Disabled: val }),
						Error: fieldErrors.Disabled,
						}}
						BlockSupplier={{
						BlockSupplier: BlockSupplier,
						value: pageState.BlockSupplier,
						setValue: (val) => setPageState({ ...pageState, BlockSupplier: val }),
						Error: fieldErrors.BlockSupplier,
						}}
						HoldType={{
						HoldType: HoldType,
						value: pageState.HoldType,
						setValue: (val) => setPageState({ ...pageState, HoldType: val }),
						Error: fieldErrors.HoldType,
						}}
						ReleaseDate={{
						ReleaseDate: ReleaseDate,
						value: pageState.ReleaseDate,
						setValue: (val) => setPageState({ ...pageState, ReleaseDate: val }),
						Error: fieldErrors.ReleaseDate,
						}}
						IdData={IdData}
					/>
                                               </div>
                                           </div>
                                           )}
                                       </div>
                                   </div>
                               </div>
			
	
		  <ApiResponseBox
			poptype={ptype}
			show={showError}
			errorMessage={error}
			onClose={() => setShowError(false)}
		  />
		</FormLayoutTwo>
	);
};

export default EditForm;
